<template>
  <div>
    <PageTitle :title="$t('global.site-apm')" />
    <!-- TODO: insert breadcrumbs component <Breadcrumb :links="breadcrumbs" /> -->
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
// import constants from "@/utils/constants";
// import NavLink from "@/classes/NavLink";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "SiteApmPage",
  components: { PageTitle },
  setup() {
    // plan and site are already fetched in parent component
    const site = computed(() => store.state.sites.site);
    const plan = computed(() => store.state.plans.item);
    // TODO: compute breadcrumbs array based on site and plan

    return {
      site,
      plan,
      // breadcrumbs
    };
  },
};
</script>
